<template>
  <div class="unmudl_widget">

    <div id="addCoursePopover"></div>

    <b-popover container="addCoursePopover" target="progressPopupTarget" triggers="click" :show.sync="$parent.showAddCoursePopover" :placement="'left'">
      <div class="widget_course_list add_course">

        <div class="row title_row">
          <span class="col-7 title_txt">Add/remove Courses</span>
          <span class="col-5 credit_details">
            <b-btn @click="closeAddCoursePopover" class="btn_close">
              <span class="ic-close"></span>
            </b-btn>
          </span>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row tbl_hd">
              <div class="col-9 course_name">Course Code and Course Name</div>
              <div class="col-3 credits">Credits</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 srh_fld">
              <input v-model="term" placeholder="type to narrow results">
          </div>
        </div>

        <div class="row tbl_content" v-if="planningStream && planningStream.uuid">
          <div class="col-12">
            <div class="row tbl_row" v-for="catalog in filteredCatalogs">
              <div class="col-9 course_name">{{catalog.title}} </div>
              <div class="col-1 credits">
                <span class="credits_txt">{{catalog.maxCredit}}</span>
              </div>
              <div class="col-2 sec_lnk">
                <template v-if="catalog.isAdded">
                  <a href="javascript://" @click="addDeleteItem(catalog, 'DELETE')">delete</a>
                </template>
                <template v-else>
                  <a href="javascript://" @click="addDeleteItem(catalog, 'ADD')">add</a>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <span class="col-7"></span>
          <span class="col-5" style="text-align: right;">
            <b-btn @click="closeAddCoursePopover" style="background: #532a6e; height: 30px; font-size: 15px; float: right; margin-right: 10px;">done</b-btn>
          </span>
        </div>

        <div class="loading-spinner">
          <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm">
            <div class="text-center" style="color: #FFF; overflow: hidden;">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
            </div>
          </b-modal>
        </div>

      </div>
    </b-popover>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'unmudl-explore-add-completed-course',
    props: ['programId', 'programCode', 'selectedCourses'],
    data: () => {
      return {
        term: '',
        items: [],
        catalogs: [],
        addedItems: [],
        isAddDeleteClicked: false
      }
    },
    async mounted () {
      await this.populateAddedItems()
      this.loadProgramCatalogs(this.programId).then(catalogs => {
        if (catalogs && catalogs.length > 0) {
          catalogs.forEach((catalog, i) => {
            let uniqueId = this.programCode + ':' + catalog.uuid
            catalog.isAdded = ($.inArray(uniqueId, this.addedItems) !== -1)
            let index = _.findIndex(this.selectedCourses, (entity) => {
              return (catalog.catalogId === entity.catalogId)
            })
            if (index === -1) {
              this.catalogs.push(catalog)
            }
          })
        }
      })
    },
    methods: {
      ...mapActions([
        'loadPlanningStreamWithStructure',
        'loadProgramCatalogs',
        'loadAddCatalogToPlanningStream',
        'loadUpdateCourseProgramProgress'
      ]),
      closeAddCoursePopover () {
        if (this.isAddDeleteClicked) {
          window.parent.postMessage({name: 'AddCourse'}, '*')
        }
        this.$parent.closeProgressPopover()
        setTimeout(() => {
          window.parent.postMessage({name: 'CloseAddCourse', data: {programCode: this.programCode}}, '*')
        }, 0)
      },
      addDeleteItem (catalog, action) {
        this.$refs.loadingModal.show()
        let entity = {
          action: action,
          title: catalog.title,
          entityType: 'catalog',
          originUuid: catalog.uuid,
          programCode: this.programCode,
          creditsEarned: catalog.maxCredit
        }
        this.loadAddCatalogToPlanningStream({uuid: this.planningStream.uuid, entity: entity}).then(value => {
          if (value) {
            this.populateAddedItems()
            this.loadUpdateCourseProgramProgress({streamId: this.planningStream.uuid, programId: this.programId}).then(resp => {
              this.isAddDeleteClicked = true
              let uniqueId = this.programCode + ':' + catalog.uuid
              catalog.isAdded = ($.inArray(uniqueId, this.addedItems) !== -1)
              setTimeout(() => {
                this.$refs.loadingModal.hide()
              }, 1250)
            })
          }
        })
      },
      async populateAddedItems () {
        this.addedItems = []
        await this.loadPlanningStreamWithStructure()
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let entities = JSON.parse(childStructure)
              if (entities.length > 0) {
                entities.forEach((entity, i) => {
                  let uniqueId = entity.programCode + ':' + entity.originUuid
                  this.addedItems.push(uniqueId)
                })
              }
            }
          }
        }
      }
    },
    computed: {
      ...mapState({
        'planningStream': state => state.widget.planningStream
      }),
      filteredCatalogs () {
        return this.catalogs.filter(catalog => {
          return catalog.title.toLowerCase().includes(this.term.toLowerCase())
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/widget/components/UnmudlExploreAddCompletedCourse.vue